import { Injectable } from "@angular/core";
import { CalculatedCodeValuesProvider, StoredCodeValuesProvider } from "..";
import { CodePanelValuesModel, FileCodeValueModel } from "../codePanelValueModel";
import { ConfUIItem, CodeDisplayStyles, CodePanel } from "../../../models";
import { SummaryDisplayStyles } from "../../../../configurator/summary/prices/SummaryDisplayStyle";
import * as Immutable from "immutable";
import { ProductDataStore } from "../../../providers/productData";
import { ConfPageSessionService } from "../../../../configurator/providers";

@Injectable()
export class CodeValueModelBuilder {

  constructor(
    public calculatedDataProvider: CalculatedCodeValuesProvider,
    public storedDataProvider: StoredCodeValuesProvider,
    public productStore: ProductDataStore,
    public storeSession: ConfPageSessionService) {

  }

  /**
   * Returns the list of values for each panel.   
   * Note!  if <confUIItem> is the instance of <GroupConfUIItem> then list must contain the multiple panels models.
   * @param confUIItem
   * @param isEditor
   * @param filterDisplayStyles
   */
  public build(confUIItem: ConfUIItem, isEditor: boolean, filterDisplayStyles: Array<CodeDisplayStyles>, configurationId: number): Immutable.List<CodePanelValuesModel> {

    // Each confUIItem represents one panel.
    let confUIItems = this.calculatedDataProvider.extractPanelConfUIItems(confUIItem);

    let valueModels: Array<CodePanelValuesModel> = [];
    confUIItems.forEach(uiItem => {
      
      let model = this.createPanelValueModel(uiItem, isEditor, filterDisplayStyles, configurationId);
      if (model)
        valueModels.push(model);

    });

    return Immutable.List(valueModels);
  }


  createPanelValueModel(uiItem: ConfUIItem, isEditor: boolean, filterDisplayStyles: Array<CodeDisplayStyles>, configurationId: number): CodePanelValuesModel {

    let panel = this.productStore.getEntity<CodePanel>(uiItem.id);

    if ((isEditor && !panel.showInConfigurator) || (!isEditor && !panel.showInSummary))
      return;

    const displayStyle = panel.displayStyle as CodeDisplayStyles;

    // Must match the filter criteria if it is defined.
    if (filterDisplayStyles && filterDisplayStyles.indexOf(displayStyle) == -1)
      return;
    
    let model = new CodePanelValuesModel();
    model.panelId = uiItem.id;

    // Supported display styles for current panel.
    // In editor mode system only supports calculated but in summary page it could have all possible options.
    const valuesDisplayPattern = isEditor ? SummaryDisplayStyles.Calculated : panel.summaryDisplayStyle as SummaryDisplayStyles;


    let codeValues = uiItem.items.map(codeUIItem => this.createCodeFileValueModel(codeUIItem, valuesDisplayPattern, configurationId));

    model.values = Immutable.List<FileCodeValueModel>(codeValues);

    return model;
  }

  createCodeFileValueModel(fileItem: ConfUIItem, displayStyle: SummaryDisplayStyles, configurationId: number): FileCodeValueModel {

    let codeValue = new FileCodeValueModel();

    switch (displayStyle) {

      case SummaryDisplayStyles.Calculated:
        {
          codeValue.calcValue = this.calculatedDataProvider.getCodeValue(fileItem.id, configurationId);
          break;
        }

      case SummaryDisplayStyles.Stored:
        {
          codeValue.storedValue = this.storedDataProvider.getCodeValue(fileItem.id, configurationId);
          break;
        }

      case SummaryDisplayStyles.Both:
        {
          codeValue.calcValue = this.calculatedDataProvider.getCodeValue(fileItem.id, configurationId);
          codeValue.storedValue = this.storedDataProvider.getCodeValue(fileItem.id, configurationId);
          break;
        }
    }


    return codeValue;
  }

}